const plus = (cssSvg = '') => {
    const svgCss = `h-4/6 left-1.5 ${cssSvg}`

    return (<svg
        className={svgCss}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
    </svg>
    )
}

export default plus